import { createAction } from '@reduxjs/toolkit';
import type { ConversationSummaryInfoSummary } from 'lib-shared-types-api';
import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import { createAsyncThunkAction } from 'utils/redux/createAsyncThunkAction';

export const actions = Object.assign(
  createActions(
    {
      CONVERSATION_GET: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_SUBMIT_MESSAGE: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_CLOSE: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_RESPONDE_TO_OFFER_ACCEPTED: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_RESPONDE_TO_OFFER_REJECTED: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_ACCEPTED: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_REJECTED: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_LINK_CHILD: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_UNLINK_CHILD: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_ADD_WRAPUP: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_CLAIM: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_TAG: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_UNTAG: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_GET_OUTBOUND_ADDRESS: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_SET_OUTBOUND_ADDRESS: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_COMPLETE_ACW: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_EXTEND_ACW: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_GET_SORT: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_SET_SORT: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_TO_PENDING: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_CANCEL_PENDING: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_PAUSE_CALL_RECORDING: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      CONVERSATION_RESUME_CALL_RECORDING: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
    },

    'CONVERSATION_CLAIM_SUCCEEDED',
    'CONVERSATION_CLAIM_FAILED',
    'CONVERSATION_CLAIM_CANCELED',

    'CONVERSATION_GET_SUCCEEDED',
    'CONVERSATION_GET_FAILED',

    'CONVERSATION_TAG_SUCCEEDED',
    'CONVERSATION_TAG_FAILED',

    'CONVERSATION_SET_OUTBOUND_ADDRESS_SUCCEEDED',
    'CONVERSATION_SET_OUTBOUND_ADDRESS_FAILED',
    'CONVERSATION_GET_OUTBOUND_ADDRESS_SUCCEEDED',
    'CONVERSATION_GET_OUTBOUND_ADDRESS_FAILED',

    'CONVERSATION_UNTAG_SUCCEEDED',
    'CONVERSATION_UNTAG_FAILED',

    'CONVERSATION_COMPLETE_ACW_SUCCEEDED',
    'CONVERSATION_COMPLETE_ACW_FAILED',

    'CONVERSATION_EXTEND_ACW_SUCCEEDED',
    'CONVERSATION_EXTEND_ACW_FAILED',

    'CONVERSATION_RESPONDE_TO_OFFER_SUCCEEDED',
    'CONVERSATION_RESPONDE_TO_OFFER_FAILED',

    'CONVERSATION_RESPONDE_TO_OFFER_ACCEPTED_SUCCEEDED',
    'CONVERSATION_RESPONDE_TO_OFFER_ACCEPTED_FAILED',

    'CONVERSATION_RESPONDE_TO_OFFER_REJECTED_SUCCEEDED',
    'CONVERSATION_RESPONDE_TO_OFFER_REJECTED_FAILED',

    'CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_ACCEPTED_SUCCEEDED',
    'CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_ACCEPTED_FAILED',

    'CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_REJECTED_SUCCEEDED',
    'CONVERSATION_RESPONDE_TO_TRANSFER_OFFER_REJECTED_FAILED',

    'CONVERSATION_GET_PREVIOUS_CONVERSATIONS_SUCCEEDED',
    'CONVERSATION_GET_PREVIOUS_CONVERSATIONS_FAILED',

    'CONVERSATION_GET_HISTORY_SUCCEEDED',
    'CONVERSATION_GET_HISTORY_FAILED',

    'CONVERSATION_LINK_CHILD_SUCCEEDED',
    'CONVERSATION_LINK_CHILD_FAILED',

    'CONVERSATION_UNLINK_CHILD_SUCCEEDED',
    'CONVERSATION_UNLINK_CHILD_FAILED',

    'CONVERSATION_ADD_MESSAGE', // Add a message to a conversation
    'CONVERSATION_ANONYMIZE_MESSAGE',
    'CONVERSATION_ADD_SUBMITTED_MESSAGE',

    'CONVERSATION_MERGE_MESSAGE',

    'CONVERSATION_SUBMIT_MESSAGE_SUCCEEDED',
    'CONVERSATION_SUBMIT_MESSAGE_FAILED',

    'CONVERSATION_CLOSE_SUCCEEDED',
    'CONVERSATION_CLOSE_FAILED',
    'CONVERSATION_WS_CLOSE', // Websocket close event.

    'CONVERSATION_ADD_WRAPUP_SUCCEEDED',
    'CONVERSATION_ADD_WRAPUP_FAILED',

    'CONVERSATION_WS_OFFER_RECEIVED',
    'CONVERSATION_WS_OFFER_CANCELED',
    'CONVERSATION_WS_TRANSFER_OFFER_RECEIVED',

    'CONVERSATION_WS_ADD_ACW',
    'CONVERSATION_WS_INTEGRATION_LOADED',

    'CONVERSATION_WS_EMAIL_DELIVERY_FAILURE',

    'CONVERSATION_WS_LANGUAGE_UPDATED',

    'CONVERSATION_WS_TAGGED',
    'CONVERSATION_WS_UNTAGGED',

    'CONVERSATION_WS_QUEUED',

    'CONVERSATION_ADD_RATING',

    'CONVERSATION_OUTBOUND_STARTED',

    'CONVERSATION_GET_BEFORE_SUCCEEDED', // Use conversations reducer to fetch conversation while waiting for REST response.

    'CONVERSATION_UNMOUNT', // Remove metaConversation from the conversation reducer.

    'CONVERSATION_SET_SORT_SUCCEEDED',
    'CONVERSATION_SET_SORT_FAILED',

    'CONVERSATION_GET_SORT_SUCCEEDED',
    'CONVERSATION_GET_SORT_FAILED',

    'CONVERSATION_TO_PENDING_SUCCEEDED',
    'CONVERSATION_TO_PENDING_FAILED',

    'CONVERSATION_CANCEL_PENDING_SUCCEEDED',
    'CONVERSATION_CANCEL_PENDING_FAILED',

    'CONVERSATION_PAUSE_CALL_RECORDING_SUCCEEDED',
    'CONVERSATION_PAUSE_CALL_RECORDING_FAILED',

    'CONVERSATION_RESUME_CALL_RECORDING_SUCCEEDED',
    'CONVERSATION_RESUME_CALL_RECORDING_FAILED',

    'CONVERSATION_WS_PENDING',
    'CONVERSATION_WS_AWAITING_PENDING',
    'CONVERSATION_WS_CANCEL_PENDING',
    'CONVERSATION_WS_OPENED',
    'CONVERSATION_WS_END_USER_PRESENCE',

    'CONVERSATION_WS_AGENT_ASSIGNED',
    'CONVERSATION_WS_AGENT_UNASSIGNED',

    'CONVERSATION_WS_REASSIGNMENT_STATUS',

    'CONVERSATION_SET_TIMELINE_GRANULARITY',

    'CONVERSATION_WS_NEW_PARTY_ADDED',
    'CONVERSATION_WS_NEW_PARTY_REMOVED',
    'CONVERSATION_WS_NEW_PARTY_RINGING',
    'CONVERSATION_WS_NEW_PARTY_BUSY',
    'CONVERSATION_WS_NEW_PARTY_FAILED',
    'CONVERSATION_WS_NEW_PARTY_NO_ANSWER',

    'CONVERSATION_WS_MESSAGE_DELIVERY_STATUS_UPDATED',

    'CONVERSATION_WS_OUTBOUND_MESSAGE_STATUS_UPDATED',

    'CONVERSATION_UPDATE_USER',
  ),
  {
    conversationUnblockAcw: createAsyncThunkAction<{ csid: string | number }>(
      'conversation/unblockAcw',
    ),
    conversationSetSummary: createAction<null | ConversationSummaryInfoSummary>(
      'conversation/setSummary',
    ),
    conversationToggleFocusMode: createAction<boolean | undefined>(
      'conversation/toggleConversationFocusMode',
    ),
    conversationSetFocusMode: createAction<boolean>(
      'conversation/setConversationFocusMode',
    ),
    conversationSetSmallLayoutSidebarOpen: createAction<boolean>(
      'conversation/setSmallLayoutSidebarOpen',
    ),
    conversationSubjectUpdate: createAction<{
      csid: number;
      subject: string;
    }>('conversation/conversationSubjectUpdate'),
  },
);
